<template>
    <div class="col-md-12">
        <div class="form-group">
            <div class="select" :class="{ selected: isSelected }">
                <select v-bind:id="name" v-bind:name="name" v-bind="validationAttributes" v-model="selectedItem">
                    <option v-for="option in options" v-bind:value="option.value" v-bind:selected="option.selected" v-bind:disabled="option.disabled" v-bind:key="option.value">
                        {{ option.text }}
                    </option>
                </select>
                <label v-bind:for="name">{{ labelText }}</label>
                <svg focusable="false" width="24" height="24" viewBox="0 0 24 24">
                    <use href="/ui/icons/custom-sprite.svg#icon-arrow-down"></use>
                </svg>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        props: {
            endpoint: {
                type: String
            },
            json: {
                type: Array
            },
            labelText: {
                type: String
            },
            name: {
                type: String
            },
            validationAttributes: {
                type: Object
            }
        },
        methods: {
            loadData: function (url) {
                axios.get(url)
                    .then(response => {
                        this.options = response.data;
                    })
                    .catch(error => {

                    });
            }
        },
        data() {
            return {
                selectedItem : '',
                options : []
            }
        },
        computed: {
            isSelected: function () {
                if (this.selectedItem !== '') {
                    return true;
                }

                return false;
            }
        },
        mounted() {
            if (this.$props.endpoint) {
                this.loadData(this.$props.endpoint);
                return;
            }

            if (this.$props.json) {
                this.options = this.$props.json;
                return;
            }
        }
    }
</script>